import React from "react";

import CreateReportTemplate from "./create-report-template";

class CreateReportTemplateController extends React.Component{

    render(){
        return (
            <CreateReportTemplate body={this.props.body} getValue={this.props.getValue} createReportConstructorTemplate={this.props.createReportConstructorTemplate} modalShowToggle={this.props.modalShowToggle} callback={this.props.callback} isCopy={this.props.isCopy} copyTemplate={this.props.copyTemplate}/>
        )
    }
}

export default CreateReportTemplateController;